import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/constants";

export const Services = () => {
  return (
    <section id="services" data-testid="services" className="relative bg-ink py-20 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="mb-14 md:mb-20">
          <h2 className="font-display uppercase leading-[0.85] text-5xl md:text-7xl lg:text-8xl">
            Services
          </h2>
        </div>

        <div className="border-t border-l border-surface-2">
          {SERVICES.map((s, i) => (
            <motion.a
              key={s.id}
              href="#book"
              data-testid={`service-row-${s.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group relative flex items-center justify-between border-r border-b border-surface-2 px-5 md:px-10 py-8 md:py-12 hover:bg-surface transition-colors"
            >
              <div className="flex items-baseline gap-5 md:gap-10">
                <span className="font-mono text-sm text-zinc-600 group-hover:text-hazard transition-colors">
                  {s.id}
                </span>
                <div>
                  <h3 className="font-display uppercase leading-none text-3xl md:text-5xl lg:text-6xl text-white group-hover:text-hazard transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-3 max-w-md text-zinc-400 text-sm md:text-base hidden sm:block">
                    {s.blurb}
                  </p>
                </div>
              </div>

              <ArrowUpRight
                size={40}
                className="shrink-0 text-zinc-600 group-hover:text-hazard group-hover:rotate-45 transition-all duration-300"
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
